"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = watchers;
var _effects = require("redux-saga/effects");
var _sagas = require("../../../astercore/auth/login/redux/sagas");
var api = _interopRequireWildcard(require("../api/api"));
var actions = _interopRequireWildcard(require("./action"));
var _ApiConst = require("../../../common/utils/ApiConst");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function* getProductDetailsAPI(params) {
  try {
    var _params$data;
    yield (0, _effects.put)(actions.GET_PRODUCT_DETAILS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getProductDetails, params === null || params === void 0 || (_params$data = params.data) === null || _params$data === void 0 ? void 0 : _params$data.params, tokenData);
    yield (0, _effects.put)(actions.GET_PRODUCT_DETAILS_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PRODUCT_DETAILS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getProductDetailsPDPAPI(params) {
  try {
    var _params$data2;
    yield (0, _effects.put)(actions.GET_PRODUCT_DETAILS_PDP_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getProductDetailsPDP, params === null || params === void 0 || (_params$data2 = params.data) === null || _params$data2 === void 0 ? void 0 : _params$data2.params, tokenData); // check params here
    yield (0, _effects.put)(actions.GET_PRODUCT_DETAILS_PDP_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PRODUCT_DETAILS_PDP_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getProductDetailsWebAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_PRODUCT_DETAILS_API_WEB.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getProductDetailsWeb, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_PRODUCT_DETAILS_API_WEB.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PRODUCT_DETAILS_API_WEB.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getProductDetailsWebUrlKeyAPI(params) {
  try {
    yield (0, _effects.put)(actions.PRODUCT_DETAILS_WEB_URL_KEY_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getProductDetailsWebUrlKey, params.data.params.urlKey, params.data.params.categoryId, tokenData);
    yield (0, _effects.put)(actions.PRODUCT_DETAILS_WEB_URL_KEY_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.PRODUCT_DETAILS_WEB_URL_KEY_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getProductDetailsWebUrlKeyOnlyAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_PRODUCT_DETAILS_WEB_URL_KEY_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getProductDetailsWebUrlKeyOnly, params.data.params.urlKey, tokenData);
    yield (0, _effects.put)(actions.GET_PRODUCT_DETAILS_WEB_URL_KEY_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PRODUCT_DETAILS_WEB_URL_KEY_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getProductByFilterAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_PRODUCT_BY_FILTER_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getProductByFilter, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_PRODUCT_BY_FILTER_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PRODUCT_BY_FILTER_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getRecommendedProductsAPI(params) {
  try {
    var _params$data3;
    yield (0, _effects.put)(actions.GET_RECOMMENDED_PRODUCTS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getRecommendedProducts, params === null || params === void 0 || (_params$data3 = params.data) === null || _params$data3 === void 0 ? void 0 : _params$data3.params, tokenData);
    yield (0, _effects.put)(actions.GET_RECOMMENDED_PRODUCTS_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_RECOMMENDED_PRODUCTS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getQuickFilterAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_QUICK_FILTER_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getQuickFilter, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_QUICK_FILTER_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_QUICK_FILTER_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getProductFilterAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_PRODUCT_FILTER_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getProductFilter, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_PRODUCT_FILTER_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PRODUCT_FILTER_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getProductsBySearchAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_PRODUCTS_BY_SEARCH_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getProductsBySearch, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_PRODUCTS_BY_SEARCH_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PRODUCTS_BY_SEARCH_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getProductsByCategoryAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_PRODUCTS_BY_CATEGORY_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getProductsByCategory, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_PRODUCTS_BY_CATEGORY_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PRODUCTS_BY_CATEGORY_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getProductsByBrandAPI(params) {
  try {
    var _params$data4;
    if (!(params !== null && params !== void 0 && (_params$data4 = params.data) !== null && _params$data4 !== void 0 && (_params$data4 = _params$data4.params) !== null && _params$data4 !== void 0 && _params$data4.hideLoader)) {
      yield (0, _effects.put)(actions.GET_PRODUCTS_BY_BRAND_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getProductsByBrand, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_PRODUCTS_BY_BRAND_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PRODUCTS_BY_BRAND_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getProductRichMediaContentAPI(params) {
  try {
    if (!_ApiConst.isThereMobile) {
      yield (0, _effects.put)(actions.GET_PRODUCT_RICH_MEDIA_CONTENT_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getProductRichMediaContent, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_PRODUCT_RICH_MEDIA_CONTENT_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PRODUCT_RICH_MEDIA_CONTENT_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getProductPromotionRulesAPI(params) {
  try {
    if (!_ApiConst.isThereMobile) {
      yield (0, _effects.put)(actions.GET_PRODUCT_PROMOTION_RULES_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getProductPromotionRules, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_PRODUCT_PROMOTION_RULES_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_PRODUCT_PROMOTION_RULES_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getProductsByAutoSuggestAPI(params) {
  // console.log('===saga start', Date.now());
  try {
    yield (0, _effects.put)(actions.GET_PRODUCTS_BY_AUTOSUGGEST_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getProductsByAutoSuggest, params.data.params, tokenData);
    // console.log('===mainResponse', mainResponse);
    // console.log('===api file end', Date.now());
    yield (0, _effects.put)(actions.GET_PRODUCTS_BY_AUTOSUGGEST_API.success(mainResponse));
    // console.log('===saga end', Date.now());
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    // console.log('===err', err);
    // console.log('===saga end', Date.now());
    yield (0, _effects.put)(actions.GET_PRODUCTS_BY_AUTOSUGGEST_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getTrendingProductsBySearchAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_TRENDING_PRODUCTS_BY_SEARCH_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getTrendingProductsBySearch, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_TRENDING_PRODUCTS_BY_SEARCH_API.success(mainResponse));
  } catch (err) {
    yield (0, _effects.put)(actions.GET_TRENDING_PRODUCTS_BY_SEARCH_API.failure(err));
  }
}
function* getCommonProductCarouselBySearchAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_COMMON_PRODUCT_CAROUSEL_BY_SEARCH_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getCommonProductCarouselApiBySearch, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_COMMON_PRODUCT_CAROUSEL_BY_SEARCH_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_COMMON_PRODUCT_CAROUSEL_BY_SEARCH_API.failure(err));
  }
}
function* getEssentialProductsBySearchAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_ESSENTIAL_PRODUCTS_BY_SEARCH_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getEssentialProductsBySearch, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_ESSENTIAL_PRODUCTS_BY_SEARCH_API.success(mainResponse));
  } catch (err) {
    yield (0, _effects.put)(actions.GET_ESSENTIAL_PRODUCTS_BY_SEARCH_API.failure(err));
  }
}
function* getNewArrivalsProductsBySearchAPI(params) {
  try {
    yield (0, _effects.put)(actions.GET_NEW_ARRIVALS_PRODUCTS_BY_SEARCH_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getNewArrivalsProductsBySearch, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_NEW_ARRIVALS_PRODUCTS_BY_SEARCH_API.success(mainResponse));
  } catch (err) {
    yield (0, _effects.put)(actions.GET_NEW_ARRIVALS_PRODUCTS_BY_SEARCH_API.failure(err));
  }
}
function* getBestSellerProductsBySearchAPI(requestParams) {
  const {
    onSuccess,
    onFailure,
    params
  } = requestParams.data;
  try {
    yield (0, _effects.put)(actions.GET_BEST_SELLER_PRODUCTS_BY_SEARCH_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getBestSellerProductsBySearch, params, tokenData);
    yield (0, _effects.put)(actions.GET_BEST_SELLER_PRODUCTS_BY_SEARCH_API.success(mainResponse));
    onSuccess && onSuccess(mainResponse);
  } catch (err) {
    yield (0, _effects.put)(actions.GET_BEST_SELLER_PRODUCTS_BY_SEARCH_API.failure(err));
    onFailure && onFailure(err);
  }
}
function* getREProductsForCarouselAPI(requestParams) {
  const {
    onSuccess,
    onFailure,
    params
  } = requestParams.data;
  try {
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getREProductsForCarousel, params, tokenData);
    onSuccess && onSuccess(mainResponse);
  } catch (err) {
    onFailure && onFailure(err);
  }
}
function* getProductsFromCommonCarouselAPI(requestParams) {
  const {
    onSuccess,
    onFailure,
    params
  } = requestParams.data;
  try {
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getProductsFromCommonCarousel, params, tokenData);
    onSuccess && onSuccess(mainResponse);
  } catch (err) {
    onFailure && onFailure(err);
  }
}
function* getFBTProductsBySearchAPI(params) {
  try {
    var _params$data5;
    if (!_ApiConst.isThereMobile) {
      yield (0, _effects.put)(actions.GET_FBT_BY_SEARCH_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getFBTProductsBySearch, params.data.params, tokenData);
    yield (0, _effects.put)(actions.GET_FBT_BY_SEARCH_API.success(mainResponse));
    if (params !== null && params !== void 0 && (_params$data5 = params.data) !== null && _params$data5 !== void 0 && _params$data5.onSuccess) {
      var _mainResponse$data;
      params.data.onSuccess((_mainResponse$data = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.data) !== null && _mainResponse$data !== void 0 ? _mainResponse$data : {});
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_FBT_BY_SEARCH_API.failure(err));
  }
}
function* hitNotifyForStockSaga(params) {
  try {
    var _params$data6;
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.hitNotifyAPI, params.data.params, tokenData);
    if (params !== null && params !== void 0 && (_params$data6 = params.data) !== null && _params$data6 !== void 0 && _params$data6.onSuccess) {
      var _mainResponse$data2;
      params.data.onSuccess((_mainResponse$data2 = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.data) !== null && _mainResponse$data2 !== void 0 ? _mainResponse$data2 : {});
    }
  } catch (err) {
    params.data.onFailure(err);
  }
}
function* hitNotifyForDownloadAppLinkSaga(params) {
  try {
    var _params$data7;
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.hitNotifyDownloadAppLinkAPI, params.data.requestParams, tokenData);
    if (params !== null && params !== void 0 && (_params$data7 = params.data) !== null && _params$data7 !== void 0 && _params$data7.onSuccess) {
      params.data.onSuccess(mainResponse !== null && mainResponse !== void 0 ? mainResponse : {});
    }
  } catch (err) {
    params.data.onFailure(err);
  }
}
function* watchers() {
  yield (0, _effects.takeLatest)(actions.GET_PRODUCT_DETAILS, getProductDetailsAPI);
  yield (0, _effects.takeLatest)(actions.GET_PRODUCT_DETAILS_PDP, getProductDetailsPDPAPI);
  yield (0, _effects.takeLatest)(actions.GET_PRODUCT_DETAILS_WEB, getProductDetailsWebAPI);
  yield (0, _effects.takeLatest)(actions.PRODUCT_DETAILS_WEB_URL_KEY, getProductDetailsWebUrlKeyAPI);
  yield (0, _effects.takeLatest)(actions.GET_PRODUCT_DETAILS_WEB_URL_KEY, getProductDetailsWebUrlKeyOnlyAPI);
  yield (0, _effects.takeLatest)(actions.GET_RECOMMENDED_PRODUCTS, getRecommendedProductsAPI);
  yield (0, _effects.takeLatest)(actions.GET_PRODUCT_BY_FILTER, getProductByFilterAPI);
  yield (0, _effects.takeEvery)(actions.GET_PRODUCT_BY_FILTER_LANDING, getProductByFilterAPI);
  yield (0, _effects.takeLatest)(actions.GET_QUICK_FILTER, getQuickFilterAPI);
  yield (0, _effects.takeLatest)(actions.GET_PRODUCT_FILTER, getProductFilterAPI);
  yield (0, _effects.takeLatest)(actions.GET_PRODUCTS_BY_SEARCH, getProductsBySearchAPI);
  yield (0, _effects.takeEvery)(actions.GET_PRODUCTS_BY_CATEGORY, getProductsByCategoryAPI);
  yield (0, _effects.takeEvery)(actions.GET_PRODUCTS_BY_BRAND, getProductsByBrandAPI);
  yield (0, _effects.takeLatest)(actions.GET_PRODUCT_RICH_MEDIA_CONTENT, getProductRichMediaContentAPI);
  yield (0, _effects.takeLatest)(actions.GET_PRODUCT_PROMOTION_RULES, getProductPromotionRulesAPI);
  yield (0, _effects.takeLatest)(actions.GET_PRODUCTS_BY_AUTOSUGGEST, getProductsByAutoSuggestAPI);
  yield (0, _effects.takeLatest)(actions.GET_TRENDING_PRODUCTS_BY_SEARCH, getTrendingProductsBySearchAPI);
  yield (0, _effects.takeEvery)(actions.GET_COMMON_PRODUCT_CAROUSEL_BY_SEARCH, getCommonProductCarouselBySearchAPI);
  yield (0, _effects.takeLatest)(actions.ESSENTIAL_PRODUCTS_BY_SEARCH, getEssentialProductsBySearchAPI);
  yield (0, _effects.takeLatest)(actions.NEW_ARRIVALS_PRODUCTS_BY_SEARCH, getNewArrivalsProductsBySearchAPI);
  yield (0, _effects.takeLatest)(actions.BEST_SELLER_PRODUCTS_BY_SEARCH, getBestSellerProductsBySearchAPI);
  yield (0, _effects.takeEvery)(actions.RE_PRODUCTS_FOR_CAROUSEL, getREProductsForCarouselAPI);
  yield (0, _effects.takeEvery)(actions.GET_PRODUCTS_FROM_COMMON_CAROUSEL, getProductsFromCommonCarouselAPI);
  yield (0, _effects.takeEvery)(actions.FBT_PRODUCTS_BY_SEARCH, getFBTProductsBySearchAPI);
  yield (0, _effects.takeEvery)(actions.HIT_NOTIFY_ME, hitNotifyForStockSaga);
  yield (0, _effects.takeEvery)(actions.HIT_NOTIFY_DOWNLOAD_APP_LINK, hitNotifyForDownloadAppLinkSaga);
}